
import { useState } from "react";
import { useToast } from "@/hooks/use-toast";
import { useStripeSubscription } from "@/hooks/useStripeSubscription";
import { useAIStaffData } from "@/hooks/useAIStaffData";
import { logger } from "@/lib/logger";

export function useSubscriptionManagement(specificStaffId?: string) {
  const { toast } = useToast();
  const { isSubmitting, fetchSubscription, cancelSubscription } = useStripeSubscription();
  const { fetchCurrentUser, fetchBusinessId, fetchAIStaff } = useAIStaffData();

  const handleCancelSubscription = async () => {
    try {
      const userId = await fetchCurrentUser();
      if (!userId) {
        toast({
          title: "Authentication required",
          description: "Please sign in to cancel your subscription.",
          variant: "destructive",
        });
        return;
      }
      
      const businessId = await fetchBusinessId(userId);
      if (!businessId) {
        toast({
          title: "Business not found",
          description: "Could not find your business profile.",
          variant: "destructive",
        });
        return;
      }
      
      const subId = await fetchSubscription(businessId);
      if (!subId) {
        toast({
          title: "No active subscription",
          description: "You don't have an active subscription to cancel.",
          variant: "destructive",
        });
        return;
      }
      
      const success = await cancelSubscription(businessId, subId);
      
      if (success) {
        if (specificStaffId) {
          fetchAIStaff(specificStaffId);
        } else {
          fetchAIStaff();
        }
      }
      
    } catch (error) {
      logger.error({
        message: "Failed to cancel subscription",
        error: error instanceof Error ? error : new Error(String(error)),
        context: { specificStaffId }
      });
      
      toast({
        title: "Error",
        description: "Failed to cancel subscription. Please try again.",
        variant: "destructive",
      });
    }
  };

  return {
    isSubmitting,
    handleCancelSubscription
  };
}
